import React, { useCallback } from 'react';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import FavStarFillIcon from '@wix/da-ds/pkg/Icons/24x24/FavStarFill';
import { BiData, BiContextProvidedValue, } from '@wix/da-bi/pkg/events';
import useDeviationStats from '../useDeviationStats';
import Stat from '../Stat';
var FaveStat = function (_a) {
    var deviation = _a.deviation, onlyNumbers = _a.onlyNumbers, className = _a.className, withUserList = _a.withUserList, showFavouritedByModal = _a.showFavouritedByModal;
    var _b = useDeviationStats(deviation), faves = _b.faves, isFavouritable = _b.isFavouritable;
    var openFavouritedModal = useCallback(function () {
        faves > 0 && showFavouritedByModal(deviation);
    }, [faves, showFavouritedByModal, deviation]);
    return !isFavouritable ? null : (React.createElement(Stat, { className: className, deviation: deviation, icon: FavStarFillIcon, statNameLocaleKey: "deviation.stats.faves", statCount: faves, onlyNumbers: onlyNumbers, userListType: withUserList ? 'favourite' : undefined, dataHook: BiDataHook.DEVIATION_FAVES_COUNTER, tooltipDataHook: BiDataHook.DEVIATION_FAVERS_LIST, onClick: openFavouritedModal, biData: BiData({
            evid: 2,
            click_info: 'favourites',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
        }) }));
};
FaveStat.displayName = 'FaveStat';
export default FaveStat;
//# sourceMappingURL=FaveStat.js.map